import { FC, useMemo, useState } from 'react';
import { WalletAddress, useExplorerClusterAddressListQuery } from '@apolloGenerated';
import { Meta } from '@graph/models';
import { Toggle, LoaderOverlay, TableController, Spacer } from '@rubin-dev/goblin';
import { renderCellAmount, renderCellHash, renderCellToken } from '@shared/ui';
import { useSidebarData } from '@graph-sidebar-module/shared';
import {
  headersAddresses,
  PAGE_SIZE,
  TabsAddressesConst,
  TABLES_ADDRESSES_TABS,
} from '../../conts';
import styles from './styles.module.scss';

export const ClusterAddresses: FC = () => {
  const { hash, network } = useSidebarData();
  const [tab, setTab] = useState(TabsAddressesConst.ALL);
  const [page, setPage] = useState(1);

  const { loading, data, previousData } = useExplorerClusterAddressListQuery({
    variables: {
      req: {
        network,
        page,
        pageSize: PAGE_SIZE,
        cluster: hash,
      },
    },
  });

  const rowTemplate = (walletAddress: WalletAddress) => {
    return {
      hashUniq: walletAddress.address,
      hash: renderCellHash({
        hash: walletAddress.address,
        type: 'address',
        network,
      }),
      token: renderCellToken({ token: Meta.network }),
      balance: renderCellAmount({
        amount: walletAddress.balance || '0',
      }),
      transactions: renderCellToken({ token: String(walletAddress.transactions || 0) }),
    };
  };

  const items = useMemo(
    () =>
      (
        (data?.explorerClusterAddressList.edge ||
          previousData?.explorerClusterAddressList.edge ||
          []) as WalletAddress[]
      ).map(rowTemplate),
    [data, rowTemplate],
  );

  return (
    <div className={styles.clusterAddresses}>
      {loading && <LoaderOverlay show />}
      <Toggle
        initValue={tab}
        items={TABLES_ADDRESSES_TABS()}
        onChange={setTab}
        size="small"
      />
      <Spacer size={12} />
      <TableController
        data={items}
        headers={headersAddresses()}
        total={Number(data?.explorerClusterAddressList?.pager?.total || 0)}
        pageSize={PAGE_SIZE}
        onChangePage={setPage}
      />
    </div>
  );
};
